import React, {useState, useEffect, useContext} from "react";
import {Button} from "antd";
import {UserContext} from "@context/UserContext";

const ListItemMessage = props => {
    const {message, onClick} = props;
    const {user} = useContext(UserContext);

    return (
        <tr>
            <td style={{width:'80%'}}>
                <Button type="link" className={'ch-link ch-list-item-title ch-message-subject' + (message.read ? ' read' : '')} onClick={onClick}>{message.subject}</Button>
            </td>
            <td>
                {message.createDate !== undefined ? user.dateFormat.format(message.createDate) : ''}
            </td>
            <td>
                {message.expiryDate !== undefined ? user.dateFormat.format(message.expiryDate) : ''}
            </td>
            <td>
                {message.senderName}
            </td>
        </tr>
    )
}

export default ListItemMessage;